const emptyReportingState = {
  // Access check
  access: null,
  isLoadingAccess: false,
  accessError: null,

  // Current/latest report
  currentReport: null,
  isLoadingReport: false,
  reportError: null,

  // Reports list (for version history)
  reports: [],
  isLoadingReports: false,
  reportsError: null,
  reportsMeta: null,

  // Trigger/generation state
  isTriggering: false,
  triggerError: null,

  // Polling state
  isPolling: false,
  pollInterval: null,

  // Edit answer state
  isUpdatingAnswer: false,
  editingQuestionId: null,
  updateAnswerError: null,

  // Regenerate answer state
  isRegeneratingAnswer: false,
  regeneratingQuestionId: null,
  regenerateAnswerError: null,

  // Clone report state
  isCloning: false,
  cloneError: null,

  // Export PDF state
  isExportingPdf: false,
  exportPdfError: null,

  // Export Word state
  isExportingWord: false,
  exportWordError: null,

  // Export CSV state
  isExportingCsv: false,
  exportCsvError: null,

  // Update particulars state
  isUpdatingParticulars: false,
  particularsError: null
}

export default emptyReportingState
